(function () {
  if (window.__popupBundleHandlerAttached) return;
  window.__popupBundleHandlerAttached = true;

  // Enforce quantity max against stock when modal opens and when + is clicked at the limit
  function validateQuantity(modal) {
    const input = modal.querySelector('.pp-quantity-input');
    if (!input) return;
    const max = input.hasAttribute('max') ? parseInt(input.getAttribute('max')) : null;
    if (max === null) return;
    // Clamp current value to max
    if (parseInt(input.value) > max) input.value = max;
    // Force validateQtyRules inside quantity-input by dispatching a change event
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // Run validation each time a product preview modal finishes opening
  document.addEventListener('modal:handleAfterShow', function (event) {
    const modal = event.target;
    if (modal && modal.tagName && modal.tagName.toLowerCase() === 'basic-modal') {
      validateQuantity(modal);
    }
  });

  // Also intercept + button clicks on the quantity input to enforce max immediately
  document.addEventListener('click', function (event) {
    const plusBtn = event.target.closest('quantity-input button[name="plus"]');
    if (!plusBtn) return;
    const modal = plusBtn.closest('basic-modal');
    if (!modal) return;
    const input = modal.querySelector('.pp-quantity-input');
    if (!input) return;
    const max = input.hasAttribute('max') ? parseInt(input.getAttribute('max')) : null;
    if (max !== null && parseInt(input.value) >= max) {
      event.stopImmediatePropagation();
      plusBtn.setAttribute('disabled', '');
    }
  }, true); // capture phase so it runs before quantity-input's own handler

  // Add to Bundle handler
  document.addEventListener('click', function (event) {
    const btn = event.target.closest('.js-popup-add-to-bundle');
    if (!btn) return;

    event.preventDefault();

    const modal = btn.closest('basic-modal');
    if (!modal) return;

    const variantSelect = modal.querySelector('select.pp-variant-select');
    if (!variantSelect) return;

    const selectedOption = variantSelect.options[variantSelect.selectedIndex];
    const variantId = selectedOption.value;
    const variantPrice = parseFloat(selectedOption.dataset.price || 0);

    const quantityInput = modal.querySelector('.pp-quantity-input');
    const rawQty = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
    const max = quantityInput && quantityInput.hasAttribute('max') ? parseInt(quantityInput.getAttribute('max')) : null;
    const quantity = max !== null ? Math.min(Math.max(1, rawQty), max) : Math.max(1, rawQty);

    // Collect personalization properties from inputs with data-bundle-prop
    const properties = {};
    modal.querySelectorAll('[data-bundle-prop]').forEach(function (input) {
      const val = input.value.trim();
      if (val) properties[input.dataset.bundleProp] = val;
    });

    // Use first visible slide image as thumbnail
    const firstSlideImg = modal.querySelector('.product__media-item[data-media-index="0"] img');
    const thumbnail = firstSlideImg ? firstSlideImg.cloneNode(true) : document.createElement('img');

    // Find the products-bundle-selection element on the page
    const bundleEl = document.querySelector('products-bundle-selection');
    if (!bundleEl) {
      console.warn('card-product-popup-bundle: no products-bundle-selection found on page.');
      return;
    }

    bundleEl.addToBundle({
      productId: btn.dataset.productId,
      id: variantId,
      thumbnail: thumbnail,
      price: variantPrice * quantity,
      quantity: quantity,
      properties: Object.keys(properties).length > 0 ? properties : null,
    });

    // Close the modal after adding
    if (typeof modal.hide === 'function') {
      modal.hide();
    }
  });
})();
